// eslint-disable-next-line
import {
    UserLayout,
    BasicLayout,
    RouteView,
    PageView
} from '@/components/layouts'

export const asyncRouterMap = [{
    path: '/',
    name: 'index',
    meta: {
        title: '首页'
    },
    component: BasicLayout,
    redirect: '/dashboard/analysis',
    children: [{
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/analysis',
        component: RouteView,
        meta: {
            title: '仪表盘',
            keepAlive: true,
            icon: 'dashboard'
        },
        children: [{
            path: '/dashboard/analysis',
            name: 'Analysis',
            component: () => import('@/views/dashboard/Analysis'),
            meta: { title: '分析页', keepAlive: false }
        }, {
            path: '/dashboard/monitor',
            name: 'Monitor',
            component: () => import('@/views/dashboard/Monitor'),
            meta: { title: '监控页', keepAlive: true }
        }, {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/views/dashboard/Workplace'),
            meta: { title: '工作台', keepAlive: true }
        }]
    }, {
        path: '/form',
        redirect: '/form/basic-form',
        component: PageView,
        meta: { title: '表单页', icon: 'form' },
        children: [{
            path: '/form/base-form',
            name: 'BaseForm',
            component: () => import('@/views/form/BasicForm'),
            meta: { title: '基础表单', keepAlive: true }
        }, {
            path: '/form/step-form',
            name: 'StepForm',
            component: () => import('@/views/form/StepForm'),
            meta: { title: '分步表单', keepAlive: true }
        }, {
            path: '/form/advanced-form',
            name: 'AdvanceForm',
            component: () => import('@/views/form/AdvancForm'),
            meta: { title: '高级表单', keepAlive: true }
        }]
    }, {
        path: '/list',
        name: 'list',
        component: PageView,
        redirect: '/list/query-list',
        meta: { title: '列表页', icon: 'table' },
        children: [{
            path: '/list/query-list',
            name: 'QueryList',
            component: () => import('@/views/list/TableList'),
            meta: { title: '查询表格', keepAlive: true }
        }, {
            path: '/list/tree-list',
            name: 'TreeList',
            component: () => import('@/views/list/TreeList'),
            meta: { title: '树目录表格', keepAlive: true }
        }, {
            path: '/list/edit-table',
            name: 'EditList',
            component: () => import('@/views/list/TableInnerEditList'),
            meta: { title: '内联编辑表格', keepAlive: true }
        }, {
            path: '/list/user-list',
            name: 'UserList',
            component: () => import('@/views/list/UserList'),
            meta: { title: '用户列表', keepAlive: true }
        }, {
            path: '/list/role-list',
            name: 'RoleList',
            component: () => import('@/views/list/RoleList'),
            meta: { title: '角色列表', keepAlive: true }
        }, {
            path: '/list/system-role',
            name: 'SystemRole',
            component: () => import('@/views/role/RoleList'),
            meta: { title: '角色列表2', keepAlive: true }
        }, {
            path: '/list/permission-list',
            name: 'PermissionList',
            component: () => import('@/views/list/PermissionList'),
            meta: { title: '权限列表', keepAlive: true }
        }, {
            path: '/list/basic-list',
            name: 'BasicList',
            component: () => import('@/views/list/StandardList'),
            meta: { title: '标准列表', keepAlive: true }
        }, {
            path: '/list/card',
            name: 'CardList',
            component: () => import('@/views/list/CardList'),
            meta: { title: '卡片列表', keepAlive: true }
        }, {
            path: '/list/search',
            name: 'SearchList',
            component: () => import('@/views/list/SearchLayout'),
            redirect: '/list/search/article',
            meta: { title: '搜索列表', keepAlive: true },
            children: [{
                path: '/list/search/article',
                name: 'SearchArticles',
                component: () => import('../views/list/TableList'),
                meta: { title: '搜索列表（文章）' }
            }, {
                path: '/list/search/project',
                name: 'SearchProjects',
                component: () => import('../views/list/TableList'),
                meta: { title: '搜索列表（项目）' }
            }, {
                path: '/list/search/application',
                name: 'SearchApplications',
                component: () => import('../views/list/TableList'),
                meta: { title: '搜索列表（应用）' }
            }]
        }]
    }, {
        path: '/profile',
        name: 'profile',
        component: RouteView,
        redirect: '/profile/basic',
        meta: { title: '详情页', icon: 'profile' },
        children: [{
            path: '/profile/basic',
            name: 'ProfileBasic',
            component: () => import('@/views/profile/Basic'),
            meta: { title: '基础详情页' }
        }, {
            path: '/profile/advanced',
            name: 'ProfileAdvanced',
            component: () => import('@/views/profile/Advanced'),
            meta: { title: '高级详情页' }
        }]
    }, {
        path: '/result',
        name: 'result',
        component: PageView,
        redirect: '/result/success',
        meta: { title: '结果页', icon: 'check-circle-o' },
        children: [{
            path: '/result/success',
            name: 'ResultSuccess',
            component: () => import('@/views/result/Success'),
            meta: { title: '成功', hiddenHeaderContent: true }
        }, {
            path: '/result/fail',
            name: 'ResultFail',
            component: () => import('@/views/result/Error'),
            meta: { title: '失败', hiddenHeaderContent: true }
        }]
    }, {
        path: '/exception',
        name: 'exception',
        component: RouteView,
        redirect: '/exception/403',
        meta: { title: '异常页', icon: 'warning' },
        children: [{
            path: '/exception/403',
            name: 'Exception403',
            component: () => import('@/views/exception/403'),
            meta: { title: '403' }
        }, {
            path: '/exception/404',
            name: 'Exception404',
            component: () => import('@/views/exception/404'),
            meta: { title: '404' }
        }, {
            path: '/exception/500',
            name: 'Exception500',
            component: () => import('@/views/exception/500'),
            meta: { title: '500' }
        }]
    }, {
        path: '/account',
        component: RouteView,
        name: 'account',
        meta: {
            title: '个人页',
            icon: 'user',
            keepAlive: true
        },
        children: [{
            path: '/account/center',
            name: 'center',
            component: () => import('@/views/account/UserCenter'),
            meta: {
                title: '个人中心',
                keepAlive: true,
                permission: ['user']
            }
        }, {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/SettingIndex'),
            meta: {
                title: '个人设置',
                hideHeader: true,
                keepAlive: true,
                permission: ['user']
            },
            redirect: '/account/settings/base',
            alwaysShow: true,
            children: [{
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import('@/views/account/BaseSetting'),
                meta: {
                    title: '基本设置',
                    hidden: true,
                    keepAlive: true,
                    permission: ['user']
                }
            }, {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/account/Security'),
                meta: {
                    title: '安全设置',
                    hidden: true,
                    keepAlive: true,
                    permission: ['user']
                }
            }, {
                path: '/account/settings/custom',
                name: 'CustomSettings',
                component: () => import('@/views/account/Custom'),
                meta: {
                    title: '个性化设置',
                    hidden: true,
                    keepAlive: true,
                    permission: ['user']
                }
            }, {
                path: '/account/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/account/Binding'),
                meta: {
                    title: '账户绑定',
                    hidden: true,
                    keepAlive: true,
                    permission: ['user']
                }
            }, {
                path: '/account/settings/notification',
                name: 'NotificationSettings',
                component: () => import('@/views/account/Notification'),
                meta: { title: '新消息通知', hidden: true, keepAlive: true }
            }]
        }]
    }]
}]
export const constantRouterMap = [{
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [{
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/Login')
    }]
}]
